import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { MassPostSaleJobOrders } from 'components/MassPostSaleJobs/MassPostSaleJobOrders';
import { Page } from 'layouts/Page';

export const MassPostSaleJobOrdersPage: FC = () => {
	const { jobId, processingType } = useParams<{ jobId: string; processingType: string }>();

	return (
		<Page
			title={`Mass Post Sale Job ${jobId ?? ''} ${processingType ?? ''} Orders – EAS Control Center`}
		>
			<MassPostSaleJobOrders />
		</Page>
	);
};
